export const ALERT_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
}

export const ICON_TYPES = {
  [ALERT_TYPES.SUCCESS]: 'check_circle_outline',
  [ALERT_TYPES.ERROR]: 'error',
  [ALERT_TYPES.INFO]: 'info',
  [ALERT_TYPES.WARNING]: 'warning_amber'
}